import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import './index.less?v=2';
import { getCDNAssets } from '@/utils';
import { useCookies } from 'react-cookie';
import { LOGOUT, OPTIONS_PRIVACY } from '@/constants/path';
import { useAppHomeTitle } from '@/hooks/useTitle';
import { channelNavigateTo, isDouyinAppChannel } from '@/channels';
import { trackEvent } from '@/utils/tracker';

const INFO_COLLECT_OPTION = {
  label: '个人信息收集清单',
  link: 'https://cdn.mcd.cn/cms/pages/collectList.html',
};

const INFO_SHARING_OPTION = {
  label: '个人信息共享清单',
  link: 'https://cdn.mcd.cn/cms/pages/shareList.html',
};

const PRIVACY_INFO_OPTION = {
  label: '隐私政策摘要',
  /**
   * sit：https://cdn-sit.mcdchina.net/cms/pages/privacySummary.html
   * uat：https://cdn-uat.mcdchina.net/cms/pages/privacySummary.html
   */
  link: 'https://cdn.mcd.cn/cms/pages/privacySummary.html',
};

const OTHER_LINK_OPTIONS = [PRIVACY_INFO_OPTION, INFO_COLLECT_OPTION, INFO_SHARING_OPTION];

const rightArrow = getCDNAssets('right_arrow.png');

const OptionsPage = () => {
  useAppHomeTitle('设置');
  const navigate = useNavigate();
  const [cookie, setCookie] = useCookies<string, { [key: string]: string }>(['sid']);

  const logged = !!cookie?.sid;

  const doLogout = () => {
    navigate(LOGOUT);
  };
  const doQuit = () => {
    trackEvent('logout', {
      belong_page: '设置页',
      button_name: '退出登录',
    });
    setCookie('sid', '', { path: '/' });
    setCookie('meddyId', '', { path: '/' });
    if (isDouyinAppChannel()) {
      channelNavigateTo(`/pages/logout/index?redirectUrl=${encodeURIComponent('/main/my')}`, {
        redirect: true,
      });
    } else {
      navigate(-1);
    }
  };

  const gotoOptionsPrivacy = useCallback(() => {
    navigate(OPTIONS_PRIVACY);
  }, [navigate]);

  const gotoAboutMcd = useCallback(() => {
    navigate('/about/mcd');
  }, [navigate]);

  const changeHref = useCallback((url: string) => {
    window.location.href = url;
  }, []);

  const aboutItemNode = useMemo(
    () => (
      <div className={'options-item'} onClick={gotoAboutMcd}>
        <div className={'item-left'}>
          <div className={'item-title'}>关于麦当劳</div>
        </div>
        <div className={'item-right'}>
          <img className={'icon'} src={rightArrow} />
        </div>
      </div>
    ),
    [gotoAboutMcd],
  );

  console.info(logged, cookie);
  if (!logged) {
    return (
      <div className={'options-list'}>
        <div className={'options-item'} onClick={() => changeHref(INFO_SHARING_OPTION.link)}>
          <div className={'item-left'}>
            <div className={'item-title'}>{INFO_SHARING_OPTION.label}</div>
          </div>
          <div className={'item-right'}>
            <img className={'icon'} src={rightArrow} />
          </div>
        </div>
        {aboutItemNode}
      </div>
    );
  }

  return (
    <div>
      {/* <Header title="设置" /> */}
      <div>
        <div className={'options-list'}>
          <div className={'options-item'} onClick={gotoOptionsPrivacy}>
            <div className={'item-left'}>
              <div className={'item-title'}>隐私</div>
            </div>
            <div className={'item-right'}>
              <img className={'icon'} src={rightArrow} />
            </div>
          </div>

          {OTHER_LINK_OPTIONS.map((item) => (
            <div className={'options-item'} key={item.link} onClick={() => changeHref(item.link)}>
              <div className={'item-left'}>
                <div className={'item-title'}>{item.label}</div>
              </div>
              <div className={'item-right'}>
                <img className={'icon'} src={rightArrow} />
              </div>
            </div>
          ))}

          <div className={'options-item'} onClick={doLogout}>
            <div className={'item-left'}>
              <div className={'item-title'}>注销</div>
              <div className={'item-tips'}>注销后无法恢复，请谨慎操作</div>
            </div>
            <div className={'item-right'}>
              <div className={'item-title'}>注销</div>
              <img className={'icon'} src={rightArrow} />
            </div>
          </div>

          {aboutItemNode}
        </div>
        <div className={'options-btm'}>
          <div className={'btm-quit'} onClick={doQuit}>
            退出登录
          </div>
        </div>
      </div>
    </div>
  );
};
export default OptionsPage;
